






import { Component, Prop, Vue } from 'vue-property-decorator';
import * as api from './store/api';
import { LetterDto } from '@/store/models';
import store from '@/store';
require("./assets/scripts/transition.min.js");
require("./assets/scripts/semantic.min.js");

@Component({
  store,
})
export default class App extends Vue {
  
  letters: LetterDto[] = [];
  async created(){
    if(store.state.isLoggedIn === false)
      this.$router.replace({name: "Login"});
    else 
      this.$router.replace({name: "MainWindow"});
     
  }
}

